<script setup lang="ts">
useDefaultMeta({
  title: 'Multi Product Shipment untuk Pengiriman Massal Efisien',
  description:
    'Otomatisasi ratusan proses pengiriman dengan Multi Product Shipment KiriminAja. Aauto label printing, & tracking real-time dalam satu sistem terintegrasi.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu fitur Kirim Paket Massal Multi Produk di KiriminAja?',
    answer:
      'Fitur ini memungkinkan Anda mengirim banyak pesanan sekaligus dari berbagai produk dan ekspedisi hanya lewat satu dashboard otomatis.'
  },
  {
    question: 'Apakah bisa upload dari webstore/website langsung?',
    answer:
      'Bisa. Anda dapat unggah file Excel, CSV, atau sinkron langsung dari webstore dengan plugin WooCommerce, plugin Shopify, atau integrasi API.'
  },
  {
    question: 'Apakah sistem bisa deteksi alamat yang sama?',
    answer:
      'Ya, sistem akan otomatis memvalidasi alamat duplikat dan mengelompokkan pesanan untuk mencegah salah kirim.'
  },
  {
    question: 'Apakah bisa edit data sebelum dikirim?',
    answer:
      'Bisa. Tersedia fitur <b>preview & edit sebelum kirim</b>, agar semua data valid sebelum pengiriman massal diproses.'
  },
  {
    question: 'Apakah mendukung semua ekspedisi di KiriminAja?',
    answer:
      'Ya, fitur ini mendukung seluruh ekspedisi express & instant yang bekerja sama dengan KiriminAja.'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Satu Dashboard, Ratusan Pesanan Terkirim Sekaligus"
      sub-title="Kirim Paket Massal"
      description="Atur dan kirim banyak pesanan dari berbagai produk dan ekspedisi dalam satu sistem otomatis. Lebih praktis, cepat, akurat, dan efisien."
      hero-image="/images/kirim-paket-massal-banner-1.webp"
      button-label="Gunakan Kirim Massal"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/packages/upload'
        })
      "
    />

    <KeunggulanKirimPaketMassalSection1 />
    <KeunggulanKirimPaketMassalSection2 />
    <KeunggulanKirimPaketMassalSection3 />
    <KeunggulanKirimPaketMassalSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanKirimPaketMassalCta />
  </div>
</template>
